import type { ContactTopic, FaqItem } from "../types";

export const WA_NUMBER = "6287895973284";
export const DISPLAY_WA_NUMBER = "+62 878-9597-3284";

export const CONTACT_TOPICS: ContactTopic[] = [
  {
    icon: "📸",
    badge: "Galura Photobooth",
    badgeColor:
      "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300 border-amber-200 dark:border-amber-800",
    title: "Sewa & Lisensi Photobooth Digital",
    description:
      'Konsultasi paket sewa kiosk 32"/43", lisensi SaaS software, frame builder kustom, & station editing terpisah.',
    defaultMessage:
      "Halo Galura, saya ingin bertanya mengenai paket sewa & lisensi Galura Photobooth Digital. Bisa dibantu informasi paket dan harganya?",
  },
  {
    icon: "💼",
    badge: "HRIS & ERP Enterprise",
    badgeColor:
      "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300 border-blue-200 dark:border-blue-800",
    title: "Sistem Admin HRIS, Payroll & ERP",
    description:
      "Diskusi kebutuhan absensi GPS selfie, otomatisasi payroll PPh 21, mutasi stok barang gudang, & modul klaim.",
    defaultMessage:
      "Halo Galura, saya ingin konsultasi mengenai implementasi Sistem Admin HRIS & ERP untuk perusahaan kami.",
  },
  {
    icon: "💻",
    badge: "Custom Development",
    badgeColor:
      "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300 border-emerald-200 dark:border-emerald-800",
    title: "Jasa Buat Aplikasi Custom (Web & Mobile)",
    description:
      "Pengembangan software kustom, mobile app (Flutter / React Native), integrasi AI, & arsitektur microservices.",
    defaultMessage:
      "Halo Galura, saya punya kebutuhan pembuatan aplikasi custom. Bisa diskusi mengenai skema proyek dan biayanya?",
  },
  {
    icon: "🌐",
    badge: "Profil Perusahaan",
    badgeColor:
      "bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300 border-sky-200 dark:border-sky-800",
    title: "Website Profil Perusahaan Premium",
    description:
      "Pembuatan website company profile modern high-converting, landing page interaktif, & optimasi SEO terpadu.",
    defaultMessage:
      "Halo Galura, saya tertarik dengan pembuatan Website Profil Perusahaan Premium. Bisa kirimkan katalog template dan penawarannya?",
  },
];

export const FAQS: FaqItem[] = [
  {
    q: "Apakah konsultasi via WhatsApp dikenakan biaya?",
    a: "Tidak sama sekali (100% Gratis). Tim spesialis teknis dan konsultan bisnis kami siap berdiskusi membantu merancang solusi digital terbaik sesuai anggaran Anda.",
  },
  {
    q: "Berapa lama estimasi balasan WhatsApp Galura?",
    a: "Rata-rata waktu tanggapan pesan WhatsApp kami adalah 5–15 menit pada jam kerja aktif (Senin – Minggu, 08:00 – 22:00 WIB).",
  },
  {
    q: "Apakah bisa mengadakan pertemuan/meeting langsung?",
    a: "Tentu! Kami berbasis di Bandung, Jawa Barat dan melayani meeting tatap muka langsung (on-site) maupun meeting virtual via Google Meet / Zoom.",
  },
  {
    q: "Bagaimana cara melakukan pemesanan sistem atau software?",
    a: "Cukup klik tombol 'Chat WhatsApp' pada topik yang Anda inginkan, lalu tim kami akan memandu langkah demonstrasi produk (demo live) hingga proposal penawaran resmi.",
  },
];
